import { useContract } from '@thirdweb-dev/react-core';

import NitroPoolFactory from '../../../abis/NitroPoolFactory.json';
import { useAsync } from 'react-use';
import { Address } from '@thirdweb-dev/sdk';
import { useConfig } from '@app/config';

export function useIsNitroPool(nftPoolAddress: Address | undefined) {
  const config = useConfig();

  const { contract } = useContract(
    config?.CONTRACTS.NITRO_POOL_FACTORY,
    NitroPoolFactory.abi
  );

  const { value } = useAsync(async () => {
    if (!contract || !nftPoolAddress) {
      return;
    }

    try {
      const res = await contract.call('getNftPoolPublishedNitroPool', [
        nftPoolAddress,
        0
      ]);

      return !!res;
    } catch (e) {
      return false;
    }
  }, [contract, nftPoolAddress]);

  return {
    isNitroPool: !!value
  };
}
